<!--
 * @Description: 日志查询页面
 * @Author: laoliu,wanqian
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <sys-log />
</template>

<script>
export default {
  mounted() {
    this.$emit("breadcrumb", {text1: '系统管理', text2: '日志查询'});
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sysmng/LogQuery.vue